import * as React from 'react';

import { cn } from 'lib/utils';

import type { ButtonProps, PositionInGroup } from './button';

export type ButtonGroupProps = React.PropsWithChildren<{
  pill?: boolean;
  outline?: boolean;
  className?: string;
}>;

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  children,
  pill,
  outline,
  className,
}) => {
  const total = React.Children.count(children);

  const items = React.useMemo(
    () =>
      React.Children.map(children, (child, index) => {
        if (!React.isValidElement<ButtonProps>(child)) {
          return child;
        }

        const position: PositionInGroup =
          index === 0 ? 'start' : index === total - 1 ? 'end' : 'middle';

        return React.cloneElement(child, {
          pill,
          outline,
          positionInGroup: position,
        });
      }),
    [children, outline, pill, total]
  );

  return (
    <div className={cn('inline-flex', className)} role="group">
      {items}
    </div>
  );
};

ButtonGroup.displayName = 'ButtonGroup';
